import { API_BASE_URL } from './api';

/**
 * Documentos do aluno que a escola emite em PDF.
 *
 * A Declaração de Frequência tem rota própria (já existia); as demais saem
 * de /students/{id}/documento/?tipo=. Quem emite é a gestão — Administrador,
 * Coordenador e Diretor(a) —, e o backend confere o mesmo.
 */
export const DOCUMENTOS_ALUNO = [
  {
    tipo: 'ficha_matricula',
    rotulo: 'Ficha de Matrícula',
    apoio: 'Ficha individual para imprimir e assinar',
    rota: (id) => `/students/${id}/documento/?tipo=ficha_matricula`,
  },
  {
    tipo: 'frequencia',
    rotulo: 'Declaração de Frequência',
    apoio: 'Dias letivos, presenças e faltas no ano',
    rota: (id) => `/students/${id}/declaracao-frequencia/`,
  },
  {
    tipo: 'matricula',
    rotulo: 'Declaração de Matrícula',
    apoio: 'Declaração simples de que está matriculado(a)',
    rota: (id) => `/students/${id}/documento/?tipo=matricula`,
  },
  {
    tipo: 'bolsa_familia',
    rotulo: 'Declaração Escolar – Bolsa Família',
    apoio: 'Modelo do PBF, com NIS, nascimento e série',
    rota: (id) => `/students/${id}/documento/?tipo=bolsa_familia`,
  },
  {
    tipo: 'transferencia',
    rotulo: 'Requerimento de Transferência',
    apoio: 'Formulário com o comprovante destacável',
    rota: (id) => `/students/${id}/documento/?tipo=transferencia`,
  },
];

// Papel exato: o Secretário (que o sistema trata como Coordenador para
// leitura) fica de fora por decisão da rede.
const PAPEIS_QUE_EMITEM = ['administrador', 'coordenador', 'diretor'];
// A Ficha de Matrícula acompanha quem matricula, e a Referência Técnica
// também cadastra alunos.
const PAPEIS_DA_FICHA = [...PAPEIS_QUE_EMITEM, 'referencia_tecnica'];

export const podeEmitirDocumentos = (user) => PAPEIS_QUE_EMITEM.includes(user?.role);
export const podeImprimirFicha = (user) => PAPEIS_DA_FICHA.includes(user?.role);

/** Os documentos que esta conta pode gerar. */
export const documentosPara = (user) => DOCUMENTOS_ALUNO.filter((d) => (
  d.tipo === 'ficha_matricula' ? podeImprimirFicha(user) : podeEmitirDocumentos(user)
));

/** Baixa a ficha de matrícula vazia, com a escola `schoolId` (opcional). */
export async function baixarFichaEmBranco(schoolId) {
  const qs = schoolId ? `?school=${encodeURIComponent(schoolId)}` : '';
  await baixarPdf(`/students/ficha-matricula-em-branco/${qs}`, 'ficha_matricula_em_branco.pdf');
}

/** Baixa o PDF do documento `tipo` do aluno. Erra com a mensagem do servidor. */
export async function baixarDocumentoAluno(aluno, tipo) {
  const doc = DOCUMENTOS_ALUNO.find((d) => d.tipo === tipo);
  if (!doc || !aluno?.id_student) throw new Error('Documento inválido.');
  await baixarPdf(doc.rota(aluno.id_student), `${tipo}_${aluno.student_name || 'aluno'}.pdf`);
}

async function baixarPdf(rota, nomePadrao) {
  const resposta = await fetch(`${API_BASE_URL}${rota}`, {
    method: 'GET',
    credentials: 'include',
  });
  if (!resposta.ok) {
    let msg = `Erro ao gerar o documento (HTTP ${resposta.status}).`;
    try {
      const data = await resposta.json();
      if (data?.error) msg = data.error;
    } catch (_) { /* resposta sem JSON */ }
    throw new Error(msg);
  }

  const blob = await resposta.blob();
  const disposition = resposta.headers.get('Content-Disposition');
  const casou = disposition && disposition.match(/filename="?([^"]+)"?/);
  const nome = casou ? casou[1] : nomePadrao;

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = nome;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
